import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';
import BtnWithText from '../game/BtnWithText';
import FontKeys from '../FontKeys';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  init() {
    this.title = null;
    this.btnGo = null;
  }

  create() {
    const oneHundred = ABCyaPhaser.Text.addText(0,166,300, 0xea7a0a, FontKeys._bpreplaybold, '100', this, true).setOrigin(0.5, 1)
      .setStroke('#c11616', 50);
    const snowballs = ABCyaPhaser.Text.addText(0,82,100, 0xea7a0a, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('snowballs'), this, true).setOrigin(0.5, 0)
      .setStroke('#c11616', 10);
    ABCyaPhaser.Text.resizeFontToFitWidth(snowballs, oneHundred.width);
    this.title = this.add.container(this.scale.width / 2, this.scale.height / 2, [oneHundred, snowballs]).setScale(0);

    this.btnGo = new BtnWithText(this, this.scale.width / 2, this.scale.height - 100, UIAssetKeys._BtnGo, ABCyaPhaser.Localization.instance.getLocalizedString('go_button'), 48).setScale(0);
    this.add.existing(this.btnGo);

    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.scene.start(Game.KEY));

    dotPop(this.title, 440);
    dotPop(this.btnGo, 440, 420);
  }
}

function dotPop(obj, time = 320, wait = 0) {
  return ABCyaPhaser.Tweens.addTween(obj, 240, { scale: 1.6, alpha: 1, delay: wait }, Phaser.Math.Easing.Quadratic.In, () => {
    ABCyaPhaser.Tweens.addTween(obj, time, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  });
}